import api from "./api";

const statsService = {};

statsService.getAppointmentStats = function ({ from, to }) {
  return api
    .get("/appointment-stats", { params: { from, to } })
    .then(({ data }) => data);
};

statsService.getIndicationStats = function ({ from, to }) {
  return api
    .get("/indication-stats", { params: { from, to } })
    .then(({ data }) => data);
};

export default statsService;
